export default __webpack_public_path__ + "static/media/light2.704ca7cb.svg";